import React from "react";
import { useNavigate } from "react-router-dom";
import { Moon, Sun, LayoutGrid } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const hubTotaal = (h, counts) => h.items.reduce((s, it) => s + (it.counter ? counts[it.counter] || 0 : 0), 0);

function RailKnop({ label, children, ...rest }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" className="v3-nv" aria-label={label} {...rest}>{children}</button>
      </TooltipTrigger>
      <TooltipContent side="right" className="v3-tip">{label}</TooltipContent>
    </Tooltip>
  );
}

/** Layout v3: smalle donkere menubalk met de 12 hubs (icoon + tooltip); klik opent het hub-paneel. */
export function V3Rail({ hubs, counts, actiefDomein, openHub, onHub, thema, onThema }) {
  const nav = useNavigate();
  return (
    <TooltipProvider delayDuration={150}>
      <nav className="v3-side" aria-label="Hoofdmenu" data-testid="v3-rail">
        <button type="button" className="v3-logo" onClick={() => nav("/dashboard")} aria-label="Naar dashboard" data-testid="v3-logo">BPT</button>
        {hubs.map((h) => {
          const Icon = h.icon;
          const n = hubTotaal(h, counts);
          return (
            <RailKnop key={h.key} label={`${h.label}${n ? ` (${n} open)` : ""}`} onClick={() => onHub(h.key)} aria-expanded={openHub === h.key}
              aria-current={actiefDomein === h.key ? "page" : undefined} data-testid={`v3-hub-${h.key}`}>
              <Icon />{n > 0 && <span className="v3-dot" data-testid={`v3-hub-badge-${h.key}`}>{n > 99 ? "99+" : n}</span>}
            </RailKnop>
          );
        })}
        <div className="v3-sp" />
        <RailKnop label="Alle tools" onClick={() => nav("/alle-tools")} data-testid="v3-alle-tools"><LayoutGrid /></RailKnop>
        <RailKnop label={thema === "donker" ? "Lichte weergave" : "Donkere weergave"} onClick={onThema} data-testid="v3-thema-knop">{thema === "donker" ? <Sun /> : <Moon />}</RailKnop>
      </nav>
    </TooltipProvider>
  );
}
